import React from 'react';
import { Card, Col, Container, Modal, Row } from 'react-bootstrap';
import axios from 'axios';
import {
    FacebookIcon,
    FacebookShareButton,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    TwitterIcon,
    TwitterShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TelegramIcon,
    TelegramShareButton,
} from 'react-share';

export default function ShareModal({ onHide, show, videoCdnUrl, video, onShare, videoId }) {
  console.log("ShareModal video:", video);
    const shareUrl = 'https://hellosuperstars.com/video?file=' + video;

    const handleShareCount = () => {
        console.log('Share counted');
        axios.get(`/api/user/audition/video/share/${videoId}`).then((res) => {
          console.log("Share count response:", res);
          if (res.status === 200) {
            onShare(prev => prev + 1);
            onHide();
          }
        });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            className="comment-modal"
            centered
        >
            <Modal.Body>
                <Card
                    sx={{ minWidth: 200 }}
                    style={{ backgroundColor: 'transparent' }}
                >
                    <Container>
                        <Row className="map-2">
                            <Col
                                md="10"
                                className="d-flex justify-content-evenly gap-2"
                            >
                                <FacebookShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <FacebookIcon size={32} round={true} />
                                    </button>
                                </FacebookShareButton>

                                <TwitterShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <TwitterIcon size={32} round={true} />
                                    </button>
                                </TwitterShareButton>

                                <WhatsappShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <WhatsappIcon size={32} round={true} />
                                    </button>
                                </WhatsappShareButton>

                                <FacebookMessengerShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <FacebookMessengerIcon
                                            size={32}
                                            round={true}
                                        />
                                    </button>
                                </FacebookMessengerShareButton>

                                <LinkedinShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <LinkedinIcon size={32} round={true} />
                                    </button>
                                </LinkedinShareButton>

                                <TelegramShareButton
                                    url={shareUrl}
                                    onClick={handleShareCount}
                                >
                                    <button>
                                        <TelegramIcon size={32} round={true} />
                                    </button>
                                </TelegramShareButton>
                            </Col>
                        </Row>
                    </Container>
                </Card>
            </Modal.Body>
        </Modal>
    );
}
